import { getFileExtensionsFromAccept, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { DropzoneProps, Dropzone as MewsUiDropzone } from '@optimus-web/core';

export const Dropzone = ({ accept, ...other }: DropzoneProps) => (
    <MewsUiDropzone
        uploadFilesText={<LocalizedText textKey={TextKey.DragAndDropFile} />}
        filesAreNotSupportedErrorMessage={
            accept ? (
                <LocalizedText
                    textKey={TextKey.FilesAreNotSupportedErrorMessage}
                    substitutes={{ supportedFileExtensions: getFileExtensionsFromAccept(accept) }}
                />
            ) : null
        }
        multipleFileDropNotAllowedErrorMessage={
            <LocalizedText textKey={TextKey.MultipleFileDropNotAllowedErrorMessage} />
        }
        accept={accept}
        {...other}
    />
);
